import React from "react";
import PropTypes from "prop-types";
import { Textarea } from "../../../../shared/Textarea/Textarea";
import { PatternAutocomplete } from "../../../PatternAutocomplete/PatternAutocomplete";
import { useDotPhrasesPatterns } from "../../../../hooks/phrases/useDotPhrasesPatterns";

export function TextAutocomplete({
  name,
  value,
  placeholder,
  onChange,
  useAutocomplete = false,
}) {
  const dotPhrasesPatterns = useDotPhrasesPatterns();

  return useAutocomplete ? (
    <PatternAutocomplete
      focusOnMount
      value={value}
      onChange={(nextValue) => onChange({ target: { name, value: nextValue } })}
      placeholder={placeholder}
      patterns={[
        {
          match: ".",
          substitutes: dotPhrasesPatterns.data,
        },
      ]}
    />
  ) : (
    <Textarea
      name={name}
      value={value || ""}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
}

TextAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  useAutocomplete: PropTypes.bool,
};

TextAutocomplete.defaultProps = {
  value: "",
  useAutocomplete: false,
};
